import { AxiosResponse } from 'axios';
import { StateCreator } from 'zustand';
// import i18n from 'i18next';

import { CombinedSlices, languages, useUderlyStore } from '.';
import { AuthToken } from '../models/AuthToken';
import { getMyself } from '../api/UderlyCore';
import { setAxiosInterceptors, clearAxiosInterceptors } from '../api/Utils';

export interface AuthSlice {
  token: AuthToken;
  setToken: (c: AuthToken) => void;
  signOut: () => void;
  fetchUserInfo: () => Promise<AxiosResponse>;
}

export const createAuthSlice: StateCreator<
  CombinedSlices,
  [],
  [],
  AuthSlice
> = (set) => ({
  token: {},
  setToken: (t: AuthToken) => set(() => ({ token: t })),
  signOut: () => set(() => {
    useUderlyStore.persist.clearStorage();

    // Clear Axios Interceptors
    clearAxiosInterceptors();

    return ({
      token: {},
      user: null,
      stores: null
    });
  }),
  fetchUserInfo: async () => {
    const response = await getMyself();

    if (response && response.status === 200 && response.data) {
      setAxiosInterceptors(useUderlyStore.getState().token.access_token, languages[response.data.language_id]);

      const { stores } = response.data;

      // i18n.changeLanguage(languages[response.data.language_id]);

      set(() => {
        return ({
          user: response.data,
          stores: stores,
          store: stores && stores[0] ? stores[0] : null,
          language: languages[response.data.language_id]
        });
      })
    }

    return response;
  }
});
